import sanitizeHTML from "@/utils/sanitizeHtml";
import DisclaimerSvg from "@/assets/svg/disclaimer.svg";
import { useContext, useMemo } from "react";
import { GlobalContext } from "@/contexts/SiteDataContext";
import { translationFunction } from "@dictionaries/i18";

export const useGetCopyright = (company: string, t: translationFunction) => {
  const siteData = useContext(GlobalContext).context.siteData;
  const { domain } = siteData;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const footerCopyright = useMemo(() => getCopyright(company, domain, t), [company, domain]);

  return footerCopyright;
};

const getCopyright = (company: string, domain: string, t: translationFunction) => {
  const year = new Date().getFullYear();
  const isFormGeniusCompany = company === "fogell";

  return (
    <span>
      {isFormGeniusCompany && (
        <>
          <i>
            {t("Provider with Unique Entity ID:")}{" "}
            <a
              href="https://sam.gov/content/home"
              target="_blank"
              rel="noreferrer">
              F589A9VUAFM1
            </a>{" "}
            {t("assigned to Form Genius *The Unique Entity ID")}{" "}
            <b>
              {t("is the official identifier for doing business with the U.S.")}{" "}
              <DisclaimerSvg style={{ top: "1px", position: "relative" }} />{" "}
              {t("as of April 4, 2022")}
            </b>
            .
          </i>
          <br />
          <br />
        </>
      )}
      © Copyright {year} <span dangerouslySetInnerHTML={{ __html: sanitizeHTML(domain) }} />.{" "}
      {t("All rights reserved.")}
    </span>
  );
};
